export default __webpack_public_path__ + "static/media/barcodeDark.97b45507.svg";